import React, { useState, useEffect } from "react";

const Footer = () => {
  const [year, setYear] = useState(0);
  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);

  return (
    <footer className="footer">
      <p>&copy; {year} GitHub Finder. Created by Shreyas Shrawage.</p>
      <div className="footer-links">
        <a href="https://www.instagram.com/shreyventure/" target="_blank" rel="noreferrer" aria-label="Instagram">
          <i className="fab fa-instagram" />
        </a>
        <a href="https://www.facebook.com/shreyas.shrawage2000" target="_blank" rel="noreferrer" aria-label="Facebook">
          <i className="fab fa-facebook" />
        </a>
        <a href="https://www.linkedin.com/in/shreyas-shrawage-2920071b2/" target="_blank" rel="noreferrer" aria-label="LinkedIn">
          <i className="fab fa-linkedin" />
        </a>
        <a href="https://twitter.com/ShreyasShrawage" target="_blank" rel="noreferrer" aria-label="Twitter">
          <i className="fab fa-twitter" />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
